import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';

import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject, from } from 'rxjs';
import { IstSiteEvaluationViewModalComponent } from './ist-site-evaluation-view-modal/ist-site-evaluation-view-modal.component';
import { IstSiteEvaluationUpdateStatusComponent } from './ist-site-evaluation-update-status/ist-site-evaluation-update-status.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { stateOptionsSample, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { MessageBoxComponent } from '../../../common/message-box/message-box.component';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-ist-site-evluation',
  templateUrl: './ist-site-evluation.component.html',
  styleUrls: ['./ist-site-evluation.component.scss']
})
export class IstSiteEvluationComponent implements OnInit {
  
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  SiteEvlutionsForm: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  userId;
  myDate1 = new Date();
  myDate = new Date(this.myDate1.setDate(new Date().getDate() + 1))
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  appstatus:boolean;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe,
  ) { }

  ngOnInit() {
    this.permission = this.commonService.getPagePermission("IST13").toLowerCase();
    this.userType = this.userService.getUserType();   
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, { });
      modalRef.componentInstance.Content={ heading: '', content: { heading: '', description: 'Please save General information details to navigate to Publications', operation: { hasConfirm: false } } } 
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }

    this.userId = this.userService.getUserDetais();
    this.appstatus=this.commonService.getIstStatus();
    this.SiteEvlutionsForm = new UntypedFormGroup({
      OrganizationStudyCenter: new UntypedFormControl(null),
      SiteEvalutionType: new UntypedFormControl(null),
      RepresentativeName: new UntypedFormControl(null),
      AssignedDateFrom: new UntypedFormControl(null),
      AssignedDateTo: new UntypedFormControl(null),
      VisitedDateFrom: new UntypedFormControl(null),
      VisitedDateTo: new UntypedFormControl(null),
    });


      this.datashareService.ApplicationID.subscribe(x => {
        this.ApplicationID = x;
      });
    this.columnDefs = [
      {
        "headerName": "Organization Study Center",
        "field": "OrganizationStudyCenter"
      },
      {
        "headerName": "Site Evaluation Type",
        "field": "SiteEvalutionType"
      },
      {
        "headerName": "Representative Name",
        "field": "RepresentativeName"
      },
      {
        "headerName": "Assigned Date",
        "field": "AssignedDateFromStr"
      },
      {
        "headerName": "Visited Date",
        "field": "VisitedDateToStr"
      }
    ];
    this.tempoperations = [
   
    ];
    this.tempoperations = []; 
   
    // if (this.permission == "new") {
    //   this.tempoperations.push({
    //     "name": "Add New",
    //     "id": "add"
    //   });
    //   this.tempoperations.push({
    //     "name": "View",
    //     "id": "view"
    //   });
    //   this.tempoperations.push({
    //     "name": "Edit",
    //     "id": "edit"
    //   });      
    //   this.tempoperations.push({
    //     "name": "Delete",
    //     "id": "delete"
    //   });
    // }

    // if (this.permission == "edit") {
    //   this.tempoperations.push({
    //     "name": "Edit",
    //     "id": "edit"
    //   });
    // }

    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Organization Study Center",
          "field": "OrganizationStudyCenter",
          "type": "text"
        },
        {
          "label": "Site Evaluation Type",
          "field": "SiteEvalutionType",
          "type": "text"
        },
        {
          "label": "Representative Name",
          "field": "RepresentativeName",
          "type": "text"
        },
        {
          "label": "Assigned Date From",
          "field": "AssignedDateFrom",
          "type": "date"
        },
        {
          "label": "Assigned Date To",
          "field": "AssignedDateTo",
          "type": "date"
        },
        {
          "label": "Visited Date From",
          "field": "VisitedDateFrom",
          "type": "date"
        },
        {
          "label": "Visited Date To",
          "field": "VisitedDateTo",
          "type": "date"
        }
      ]
    };

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.getSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }
 
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
   const modelRef= this.modalService.open(IstSiteEvaluationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true,
    });
    modelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }

    }
  }

  statusUpdate() {
    let modalRef = this['self'].modalService.open(IstSiteEvaluationUpdateStatusComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content= {
      heading: 'update',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID },
      Status: this['self'].selectedRow["StatusStr"]

    }
    modalRef.result.then(result => {
      this['self'].getSummary();
    })
  }

  add() {
    let modalRef = this['self'].modalService.open(IstSiteEvaluationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }

    }
    modalRef.result.then(result => {
      this['self'].getSummary();
    })
  }


  edit() {
    let modalRef = this['self'].modalService.open(IstSiteEvaluationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].getSummary();
    })
  }

  view() {
    const modelRef=this['self'].modalService.open(IstSiteEvaluationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-lg right modal-right',
      animation: true,
    });
    modelRef.componentInstance.Content= {
      heading: 'View',
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }

    }
  }

  delete(service, toastrService) {   
    let id = this['self'].selectedRow['ID'];
    if (this['self'].selectedRow["StatusStr"] != "2") {
      const modalRef = this['self'].modalService.open(DeleteBoxComponent, { backdrop: false});
      modalRef.componentInstance.Content={ heading: 'Delete',custommessage: 'Are you sure you want to delete this site evaluation record?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
      modalRef.result.then(result => {
        if(result == "okclick"){
        service.DeleteRecord('api/ISTSiteevaluation/Delete?RecordID=' + id).subscribe(summary => {
          if (summary["Status"] == 0) {
            this['self'].commonService.SuccessBanner("Site Evaluation details deleted successfully");
            this['self'].getSummary();
          }
          else {            
            this['self'].commonService.ErrorBanner(summary.Message);
          }
        });
      }
      })
    }
    else {
      this['self'].commonService.ValidationBanner("This Operation is not Possible for this Record");
      // this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: "This Operation is not Possible for this Record." } } });
    }   
  }

  getSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTSiteevaluation/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary); 
    });
  }

  setOperations(RawData: any): any {

    if(this.permission == "new"){
      this.tempoperations = [      
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add New Site Evaluation",
          "id": "add"
        }
      ];
        if(this.appstatus == true){
          this.tempoperations.push(
          {
            "name": "Status Update",
            "id": "statusUpdate"
          })
        }
    } 
    
    if(this.permission == "edit")
    {
      this.tempoperations = [      
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Status Update",
          "id": "statusUpdate"
        }
      ];
    }
    
    
    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if(element.CreatedBy != this.userId.ID)
      {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
         if(this.permission=="new")
         {
          tempoperations2.push({
            "name": "Add New Site Evaluation",
            "id": "add"
          })
         }
         element["Operations"]=this.setDef(tempoperations2);
      }     

      if((element.VisitedDateToStr == null || element.VisitedDateToStr == undefined) && element.CreatedBy === this.userId.ID){
        element["Operations"]=this.setDef(this.tempoperations);
      } else{
        let tempoperations3 = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        if(this.permission=="new")
        {
         tempoperations3.push({
           "name": "Add New Site Evaluation",
           "id": "add"
         })
        }
        element["Operations"]=this.setDef(tempoperations3);
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }    
    });
    return RawData;
  }

  setDef(parmoperations:any): any {   
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  getSearchSummary(searchObject) {
    this.summaryService.fetchSearchData("api/ISTSiteevaluation/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary

    });
  }
  SearchClear() {
    this.SiteEvlutionsForm.reset();
    //  this.setSummary();
  }

  AdvanceSearch() {
    var formData = this.SiteEvlutionsForm.value;
    formData["ApplicationID"] = this.ApplicationID;

        if (formData["AssignedDateFrom"] != null && formData["AssignedDateFrom"] != undefined) {
            formData["AssignedDateFrom"] = new Date(formData["AssignedDateFrom"]);
        }
        if (formData["AssignedDateFrom"] != null && formData["AssignedDateFrom"] != "") {
         formData["AssignedDateFromStr"] = this.datepipe.transform(formData["AssignedDateFrom"], 'dd-MMM-yyyy');
         }

          if (formData["AssignedDateTo"] != null && formData["AssignedDateTo"] != undefined) {
            formData["AssignedDateTo"] = new Date(formData["AssignedDateTo"]);
                }
          if (formData["AssignedDateTo"] != null && formData["AssignedDateTo"] != "") {
            formData["AssignedDateToStr"] = this.datepipe.transform(formData["AssignedDateTo"], 'dd-MMM-yyyy');
          }

          if (formData["VisitedDateFrom"] != null && formData["VisitedDateFrom"] != undefined) {
            formData["VisitedDateFrom"] = new Date(formData["VisitedDateFrom"]);
          }
          if (formData["VisitedDateFrom"] != null && formData["VisitedDateFrom"] != "") {
            formData["VisitedDateFromStr"] = this.datepipe.transform(formData["VisitedDateFrom"], 'dd-MMM-yyyy');
          }
          if (formData["VisitedDateTo"] != null && formData["VisitedDateTo"] != undefined) {
            formData["VisitedDateTo"] = new Date(formData["VisitedDateTo"]);
          }
          if (formData["VisitedDateTo"] != null && formData["VisitedDateTo"] != "") {
            formData["VisitedDateToStr"] = this.datepipe.transform(formData["VisitedDateTo"], 'dd-MMM-yyyy');
          }

    formData["AssignedDateFrom"] = null;
    formData["AssignedDateTo"] = null;
    formData["VisitedDateFrom"] = null;
    formData["VisitedDateTo"] = null;

    this.getSearchSummary(formData);
  }

  onAdvanceSearchOperation(searchFiletrs) {

  }
}
